<!--
 * @Author: 王佳宾
 * @Date: 2022-09-29 13:29:17
 * @LastEditors: 陈梦男 chenmengnan@piesat.cn
 * @LastEditTime: 2023-08-17 11:29:27
 * @Description: 管理页面
 * @FilePath: \web\src\views\Project\Manager\Index.vue
-->
<template>
  <main id="ky-manager">
    <section class="ky-manager-layout">
      <section class="ky-manager-layout-slider" v-if="hasLeft">
        <router-link custom v-slot="i" v-for="item in managerRouteList" :key="item.name" :to="item.path">
          <a-button class="button-item" :class="{ active: i.isActive }" @click="i.navigate">
            {{ item.name }}
          </a-button>
        </router-link>
      </section>
      <!-- 左侧边栏 -->
      <section class="ky-manager-layout-main">
        <!-- S 子路由 -->
        <router-view v-slot="{ Component }">
          <transition name="fade" mode="out-in" appear>
            <component :is="Component"></component>
          </transition>
        </router-view>
        <!-- <router-view/> -->
        <!-- E 子路由 -->
      </section>
      <!-- 主体 -->
    </section>
  </main>
</template>

<script setup>
import { managerRoute } from '@/router/index';
import { ref, getCurrentInstance, computed, onBeforeUpdate, onBeforeMount } from 'vue';
import { useRouter } from 'vue-router';
const router = useRouter();

let path = router.currentRoute.value.path;
const hasLeft = ref(false);
const managerRouteList = ref([]);

const getRoute = () => {
  // console.log(router.currentRoute.value, '当前路由', managerRoute, 333333333333, managerRouteList.value);
  if (router.currentRoute.value.meta.left) {
    hasLeft.value = true;
    managerRouteList.value = managerRoute.filter((item) => {
      if (item.meta.left) {
        return item;
      }
    });
  }
};
// console.log(11111, path);

onBeforeMount(() => {
  // console.log(router.currentRoute.value.path, 'onBeforeMount', 22222222);
  getRoute();
});
onBeforeUpdate(() => {
  // console.log(router.currentRoute.value, '当前路由', managerRoute, 11111111);
  path = router.currentRoute.value.path;
  if (path === '/main/project/roleManagement') {
    managerRouteList.value = managerRoute.filter((item) => {
      if (item.path === '/main/project/roleManagement') {
        return item;
      }
    });
  } else {
    managerRouteList.value = managerRoute.filter((item) => {
      if (item.path !== '/main/project/roleManagement') {
        return item;
      }
    });
  }
  getRoute();
  // console.log(managerRouteList.value);
});


</script>

<style lang="scss">
#ky-manager {
  height: 100%;
  width: 100%;
  padding-top: 1.04rem;
  background: #191405;
  color: #fff;

  .ky-manager-layout {
    position: relative;
    z-index: 100;
    display: flex;
    height: 100%;
    padding: 0.2rem 0.47rem 0.2rem 0.2rem;
    background: #191405;

    /* 左侧边栏 */
    .ky-manager-layout-slider {
      .button-item {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 0.3rem;
        padding: 0.3rem 0.1rem;
        height: auto;
        white-space: pre-line;
        background: rgba(61, 57, 47, 0.8);
        font-size: 0.16rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        text-overflow: inherit;
        color: rgba(255, 255, 255, 0.8);
        border: none;
        border-radius: 0;
        cursor: pointer;

        &:first-child {
          clip-path: polygon(100% 0, 100% 100%, 0% 74%, 0 0);

          span {
            transform: translateY(-0.1rem);
          }
        }

        &:not(:first-child) {
          margin-top: -0.3rem;
          clip-path: polygon(100% 26%, 100% 100%, 0% 74%, 0% 0%);
        }
        &:last-child {
          clip-path: polygon(100% 26%, 100% 100%, 0% 100%, 0 0);

          span {
            // margin-top: 0.3rem;
            transform: translateY(0.1rem);
          }
        }
        &.active {
          color: #fff;
          background: rgba(214, 154, 29, 0.5);
        }
      }
    }

    /* 主体 */
    .ky-manager-layout-main {
      margin-left: 0.04rem;
      flex: 1;
      width: 100%;
      // background: red;
    }
  }

  /* 路由 */
  .fade-enter-active {
    transition: all 0.2s ease-out;
  }

  .fade-leave-active {
    transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
  }

  .fade-enter-from,
  .fade-leave-to {
    transform: translateX(20px);
    opacity: 0;
  }
}
</style>
